import React from "react";
import { Reveal } from "../hooks/useReveal";
import AppBadges from "./AppBadges";
import { IMAGES } from "../mock";
import { Button } from "./ui/button";

export default function DownloadCTA({ onWaitlist }) {
  return (
    <section className="relative py-24 overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="relative rounded-[2.5rem] border border-[#2fd645]/25 bg-[#0b0f0d] overflow-hidden">
            <div className="absolute inset-0 id-radial" />
            <div className="absolute inset-0 id-grid-bg opacity-20" />
            <div className="relative grid lg:grid-cols-2 gap-8 items-center p-8 sm:p-12 lg:p-16">
              <div>
                <h2 className="font-display font-extrabold text-white text-4xl sm:text-5xl leading-tight">
                  Get the app.
                  <br />
                  <span className="text-[#2fd645] italic-display">Be first to ride.</span>
                </h2>
                <p className="mt-5 text-white/70 text-lg max-w-md">
                  Download InstantDrive on iOS and Android. Join the waitlist now
                  and we&apos;ll notify you the moment rides go live across Nigeria.
                </p>
                <div className="mt-8">
                  <AppBadges size="lg" />
                </div>
                <Button
                  onClick={onWaitlist}
                  className="mt-5 h-12 px-7 bg-white text-[#06210b] font-bold hover:bg-white/90 rounded-xl"
                >
                  Join the waitlist
                </Button>
              </div>
              <div className="relative flex justify-center">
                <div className="absolute -inset-6 bg-[#2fd645]/15 blur-3xl rounded-full" />
                <img
                  src={IMAGES.cabPhone}
                  alt="Booking a ride with InstantDrive"
                  className="relative rounded-3xl border border-white/10 object-cover w-full max-w-md h-[400px]"
                />
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
